import type { AdvAnnouncements } from '~/lib/types/AdvAnnouncements'
import { BackendApiRequest } from '../client'

export const getAdvAnnouncements = async () => {
  const { advAnnouncements } = await BackendApiRequest<{ advAnnouncements: AdvAnnouncements }>({
    url: `/v1/adv_announcements`,
  })
  return advAnnouncements
}
